// 翻译B2C 文本消息
import ajax from '@/utils/ajax';
import DOMAIN from '@/imsdk/domain';
import globalWin from '@/utils/globalWin';
// import i18n from '@/i18n';
const domain = DOMAIN.getSDKDomain();
const FACE_SPLIT_SIGN = '[face_split_sign]';
const TEXT_TRANSLATE = '/ts/translate/textTranslate';
const TRANSLATE_LANG_LIST = ['en', 'zh', 'zh-TW'];
export default function b2cTextMsgTranslate(translateConf, data) {
  return new Promise((resolve, reject) => {
    // 请求翻译接口需要增加鉴权
    // if (globalData.thirdAppConfig) {
    //   translateData.kfuin = globalData.reception.kfuin;
    //   translateData.visitorId = globalData.thirdAppConfig.visitorId; // 这里后期需要处理
    //   translateData.secretKey = globalData.thirdAppConfig.secretKey; // 这里后期需要处理
    // }
    try {
      // 替换文本中的表情
      let sourceText = `${(data || data.originMsgContent || data.originData || data.data)}`;
      const faceArr = [];
      let sourceTextArr = [];

      // 这里对文本处理去掉了表情编码中的下划线
      sourceText = sourceText.replace(/\[(.*?)\]/g, (faceMatch) => {
        faceArr.push(faceMatch);
        return FACE_SPLIT_SIGN;
      });
      sourceTextArr = sourceText.split(FACE_SPLIT_SIGN);
      // 去掉表情后如果字符串是空就不需要请求后台翻译
      if (!sourceTextArr.join('').length) {
        reject(null);
      }
      // 翻译请求数据
      const translateData = {
      // source_lang: data.translate_lang,
      // 原语言从B2C消息里获取改为auto，通过翻译君判断
        source_lang: 'auto',
        source_text_list: sourceTextArr,
        target_lang: translateConf.translateLang,
        terminal_type: 4, // 1-windows 2-android 3-iOS 4-web 5-数据分析
      };
      ajax.post(
        // `${TEXT_TRANSLATE}?kfuin=${globalData.reception.kfuin}`,
        `${domain.consolecgi}${TEXT_TRANSLATE}?kfuin=${globalWin.wpaDetail.kfuin}`,
        JSON.stringify(translateData),
        { headers: {
          'Content-Type': 'application/json; charset=utf-8',
        } },
      )
        .then((res) => {
          const result = res.data;
          if (+result.code === 0) {
            const value = result.data || {};
            if (value.source_lang === translateConf.translateLang) reject(null);
            /**
              * 1. C的原文不等于目标语言，但属于简繁英，则翻译为目标语种
              * 2. C的原文不等于简繁英，不显示翻译，显示错误提示
              * 3. C的原文等于目标语言，仅显示原文
              */
            if (value.source_lang !== translateConf.translateLang
               && TRANSLATE_LANG_LIST.indexOf(value.source_lang) !== -1) {
              // const { reception } = globalData;
              // const { kfuin } = reception;
              // const { visitorId } = reception;
              // const msgIndex = [data.sortseq, data.type].join('');
              let targetText = '';
              const targetTextList = value.target_text_list || [];
              // 这里对文本处理还原了表情编码中的下划线
              for (let i = 0; i < targetTextList.length; i++) {
                targetText = targetText + targetTextList[i] + (faceArr[i] || '');
              }
              console.error('targetText', targetText);
              resolve({
                targetText,
                type: 'success',
              });
              return;
            };
            resolve({
              type: 'fail',
            });
          };
          if (+result.code === -510) {
            resolve({
              type: 'only',
            });
          };
          resolve({
            type: 'fail',
          });
        })
        .catch(() => (resolve({ type: 'fail' })));
    } catch (e) {
      console.error('catch', e);
    }
    // reject(null);
  });
}

// 粘贴了renderChatMsg的表情转化方法，后面可以看看是否可以收敛
// function renderMsgFace(data, dir) {
//   var data = typeof globalVars.win.emoji != 'undefined' ? globalVars.win.emoji.replace_unified(data) : data,
//       faceImagePath = globalVars.isMobile ? CONF.CGI_URL.QQ_FACE : CONF.CGI_URL.COMP_SOURCE_URL + 'img/qq/';
//   return data.replace(/\[(.*?)\]/g, function($0, $1) {
//       var index;
//       if ($1.indexOf('f') == 0) {
//           $1 = $1.match(/\d+/g);
//           for (var i = 0; i < faceDict.index.length; i++) {
//               if (faceDict.index[i] == $1) {
//                   index = i;
//                   break;
//               }
//           }
//       } else if (dir != 'b2c') {
//           for (var i = 0; i < faceDict.locale.length; i++) {
//               if ($.i18n(faceDict.locale[i]) == $1) {
//                   index = i;
//                   break;
//               }
//           }
//       }
//       return index || index === 0 ? '<img src="' + faceImagePath + index + '.png" class="face"/>' : $0;
//   });
// }
